import request from "@/utils/request";

// 联系我们相关的地址的接口
export function contactList() {
    return request.post('/home/getAboutUs')
}


export function getuserInfo(userinfo) {
    return request({
      url: '/home/submitMessage',
      method: 'post',
      data:userinfo
    })
  }